import { createFileRoute } from "@tanstack/react-router";
import { loadPodcastEpisode } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/podcast/$slug")({
  loader: ({ params }) => loadPodcastEpisode({ data: { slug: params.slug } }),
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: loaderData.title,
          description: loaderData.description,
          image: loaderData.featured_image,
          url: `/podcast/${loaderData.slug}`,
        })
      : [],
    links: loaderData ? seoLinks({ url: `/podcast/${loaderData.slug}` }) : [],
  }),
  component: PodcastEpisode,
});

function PodcastEpisode() {
  const ep = Route.useLoaderData();
  return (
    <article className="mx-auto max-w-3xl px-4 py-16 md:px-8">
      <div className="mb-6 text-sm text-gray-60">
        <time>{new Date(ep.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</time>
      </div>
      <h1 className="mb-6 font-display text-4xl font-bold leading-tight text-charcoal md:text-5xl">{ep.title}</h1>
      {/* Podcast body typically contains a Buzzsprout script embed + description */}
      <div className="content group" dangerouslySetInnerHTML={{ __html: ep.html }} />
    </article>
  );
}
